<template>
	<div>
		<el-dialog title="请选择专业" width="500px" :visible.sync="visible" :close-on-click-modal="false" @close="closeMajor">
			<el-tabs v-model="majorTab" type="card">
				<el-tab-pane label="五年制高职" name="五年制高职"></el-tab-pane>
				<el-tab-pane label="三年制中专" name="三年制中专"></el-tab-pane>
				<el-tab-pane label="六年制中专" name="六年制中专"></el-tab-pane>
			
			</el-tabs>
			<div style="width: 65%; padding-bottom: 20px; padding-left: 20px;">
				<el-input placeholder="请输入内容" v-model="keyword" size="small">
					<el-button slot="append" icon="el-icon-search"></el-button>
				</el-input>
			</div>
			<div v-for="item in dataList" :key="item.id" >
				<div class="majoritem" @click="checkMajor(item)" v-if="item.item_desc==majorTab&&item.title.indexOf(keyword)>=0">
					<span style="font-weight: bold; margin-right: 10px;">{{item.item_num}}</span>
					<span>{{item.title}}【{{item.item_desc}}】</span>
					
				</div>
				<div v-if="item.children"  v-for="(m,i) in item.children" :key="i" style="padding-left: 30px;" @click="checkMajor(m)">
					<div class="majoritem"  v-if="m.item_desc==majorTab&&m.title.indexOf(keyword)>=0">
						<span style="font-weight: bold; margin-right: 10px;">{{m.item_num}}</span>
						<span>{{m.title}}【{{m.item_desc}}】</span>
						<span style="margin-left: 10px; color: #1370FB;">( {{m.lq_count?m.lq_count:0}}/{{m.plan_num}} )</span>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				visible: true,
				closing:false,
				dataList:[],
				isadmin:this.$store.state.teacherRole.isadmin,
				majorTab:"五年制高职",
				keyword:"",
				year:""
			}
		},
		mounted() {
			this.getList()
			
		},
		methods: {
			getList(){
				this.$http.post("/api/h5_majors",{pmid:window.pmid}).then(res=>{
					this.year = res.data.year
					this.dataList = res.data.data
					
				})
			},
			getRole(){//检查用户角色，如果是管理员则可以在招满之后新增
				this.$http.post("/api/get_teacher_role").then(res=>{
					
					for(let item of res.data){
						if(item.role_code.toLowerCase().indexOf("admin")>=0){
							this.isadmin = true;
							break
						}
					}
				})
			},
			checkMajor(item){
				//检查是否管理员
				this.visible = false;
				this.closing = true
				setTimeout(()=>{
					this.$parent.closeMajor(item);
					
				},250)
			},
			closeMajor(){
				if(this.closing){
					return
				}
				this.visible = false;
				
				setTimeout(()=>{
					this.$parent.closeMajor(null);
					
				},250)
			}
		}
	}
</script>
<style scoped="scoped">
	.majoritem{ border-bottom: 1px solid #ccc; padding: 5px ; cursor: pointer;}
	.majoritem:hover{background-color: #CCCCCC;}
</style>
